import React from 'react';

const XIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none" stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    >
        <path d="M18 6 6 18"/>
        <path d="m6 6 12 12"/>
    </svg>
)

export default XIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/XIcon.jsx